// extracted by mini-css-extract-plugin
export default {"form":"X1HRZNQa","active":"cnpDK3yQ","lazyImg":"GJ1s_bug"};
    if(module.hot) {
      // 1738090061102
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  